import { render, staticRenderFns } from "./tabvendas.vue?vue&type=template&id=dbbef048&scoped=true&"
import script from "./tabvendas.vue?vue&type=script&lang=js&"
export * from "./tabvendas.vue?vue&type=script&lang=js&"
import style0 from "./tabvendas.vue?vue&type=style&index=0&id=dbbef048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbef048",
  null
  
)

export default component.exports